<template>
  <div class="container">
    <div class="notice">
      <p class="title">
        网路检测
        <span class="close_btn cursor" @click.stop="close"></span>
      </p>
      <div class="content">
        <p>网络差：频繁出现视频卡顿、收不到题、声音断断续续等现象 建议检查路由器、网络连接是否正常。</p>
        <p>网络较弱：偶尔会出现视频卡顿，收不到题，建议尝试切换清晰度。</p>
        <p>网络正常：上课效果质量最佳。</p>
        <div class="btns">
          <button class="cursor" @click.stop="close">我知道了</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "common";
import utils from "utils";
if (LIMI_ENV === "electron") {
  var fs = window.require("fs");
}
export default {
  methods: {
    close() {
      this.$emit('close')
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 999999998;
  background: rgba(0, 0, 0, 0.6);
  .notice {
    width: 733px;
    height: 480px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .title {
      background: #0089ce;
      height: 75px;
      line-height: 75px;
      position: relative;
      color: #ffffff;
      font-size: 26px;
      border-radius: 14px 14px 0 0;
      span{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font-size: 18px;
        font-weight:400;
      }
      .close_btn {
        position: absolute;
        right: 35px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        background: url(../../../assets/img/common/close-icon.png) no-repeat center center;
        background-size: 20px;
      }
    }
    .content {
      background: #ffffff;
      color: #333333;
      font-size: 21px;
      height: 405px;
      padding: 10px 65px 0 35px;
      border-radius: 0 0 14px 14px;
      text-align: center;
      p{
        margin-top: 30px;
        padding-left: 65px;
        text-align: left;
       &:nth-child(3){
          background: url(../../../assets/img/video/network_good_1.png) no-repeat left top;
          background-size:37px 28px;
        }
        &:nth-child(2){
          background: url(../../../assets/img/video/network_general_1.png) no-repeat left top;
          background-size:37px 28px;
        }
        &:first-child{
          background: url(../../../assets/img/video/network_poor_1.png) no-repeat left top;
          background-size:37px 28px;
        }
      }
      button{
        width:216px;
        height:57px;
        border-radius:12px;
        font-size: 24px;
        font-family: inherit;
        margin-top:60px; 
        // &:first-child{
        //   border: 1px solid #0B8EB2;
        //   color:#0B8EB2;
        // }
        &:last-child{
          background:#008acf;
          margin-left: 25px;
          color: #ffffff;
        }
        &:last-child:hover{
          color: #b5d1d9;
          background: #4cadde;
        }
        // &:first-child:hover{
        //   border: 1px solid #006581;
        //   color: #006581;
        // }
      }
      
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/bussiness/video/networkTestDescribe.vue